export const US_STATES = [
  { abbr: "AL", name: "Alabama" },
  { abbr: "AK", name: "Alaska" },
  { abbr: "AZ", name: "Arizona" },
  { abbr: "AR", name: "Arkansas" },
  { abbr: "CA", name: "California" },
  { abbr: "CO", name: "Colorado" },
  { abbr: "CT", name: "Connecticut" },
  { abbr: "DE", name: "Delaware" },
  { abbr: "DC", name: "District of Columbia" },
  { abbr: "FL", name: "Florida" },
  { abbr: "GA", name: "Georgia" },
  { abbr: "HI", name: "Hawaii" },
  { abbr: "ID", name: "Idaho" },
  { abbr: "IL", name: "Illinois" },
  { abbr: "IN", name: "Indiana" },
  { abbr: "IA", name: "Iowa" },
  { abbr: "KS", name: "Kansas" },
  { abbr: "KY", name: "Kentucky" },
  { abbr: "LA", name: "Louisiana" },
  { abbr: "ME", name: "Maine" },
  { abbr: "MD", name: "Maryland" },
  { abbr: "MA", name: "Massachusetts" },
  { abbr: "MI", name: "Michigan" },
  { abbr: "MN", name: "Minnesota" },
  { abbr: "MS", name: "Mississippi" },
  { abbr: "MO", name: "Missouri" },
  { abbr: "MT", name: "Montana" },
  { abbr: "NE", name: "Nebraska" },
  { abbr: "NV", name: "Nevada" },
  { abbr: "NH", name: "New Hampshire" },
  { abbr: "NJ", name: "New Jersey" },
  { abbr: "NM", name: "New Mexico" },
  { abbr: "NY", name: "New York" },
  { abbr: "NC", name: "North Carolina" },
  { abbr: "ND", name: "North Dakota" },
  { abbr: "OH", name: "Ohio" },
  { abbr: "OK", name: "Oklahoma" },
  { abbr: "OR", name: "Oregon" },
  { abbr: "PA", name: "Pennsylvania" },
  { abbr: "RI", name: "Rhode Island" },
  { abbr: "SC", name: "South Carolina" },
  { abbr: "SD", name: "South Dakota" },
  { abbr: "TN", name: "Tennessee" },
  { abbr: "TX", name: "Texas" },
  { abbr: "UT", name: "Utah" },
  { abbr: "VT", name: "Vermont" },
  { abbr: "VA", name: "Virginia" },
  { abbr: "WA", name: "Washington" },
  { abbr: "WV", name: "West Virginia" },
  { abbr: "WI", name: "Wisconsin" },
  { abbr: "WY", name: "Wyoming" },
];

export const BOX12_CODES = [
  { code: "A", desc: "Uncollected social security or RRTA tax on tips" },
  { code: "B", desc: "Uncollected Medicare tax on tips" },
  { code: "C", desc: "Taxable cost of group-term life insurance over $50,000" },
  { code: "D", desc: "Elective deferrals under a section 401(k) cash or deferred arrangement" },
  { code: "E", desc: "Elective deferrals under a section 403(b) salary reduction agreement" },
  { code: "F", desc: "Elective deferrals under a section 408(k)(6) salary reduction SEP" },
  { code: "G", desc: "Elective deferrals and employer contributions to section 457(b)" },
  { code: "H", desc: "Elective deferrals under section 501(c)(18)(D)" },
  { code: "J", desc: "Nontaxable sick pay" },
  { code: "K", desc: "20% excise tax on excess golden parachute payments" },
  { code: "L", desc: "Substantiated employee business expense reimbursements" },
  { code: "M", desc: "Uncollected social security or RRTA tax on taxable cost of group-term life" },
  { code: "N", desc: "Uncollected Medicare tax on taxable cost of group-term life" },
  { code: "P", desc: "Excludable moving expense reimbursements" },
  { code: "Q", desc: "Nontaxable combat pay" },
  { code: "R", desc: "Employer contributions to Archer MSA" },
  { code: "S", desc: "Employee salary reduction contributions under section 408(p) SIMPLE" },
  { code: "T", desc: "Adoption benefits" },
  { code: "V", desc: "Income from exercise of nonstatutory stock option(s)" },
  { code: "W", desc: "Employer contributions to HSA" },
  { code: "Y", desc: "Deferrals under section 409A nonqualified deferred compensation" },
  { code: "Z", desc: "Income under section 409A nonqualified deferred compensation plan" },
  { code: "AA", desc: "Designated Roth contributions under section 401(k)" },
  { code: "BB", desc: "Designated Roth contributions under section 403(b)" },
  { code: "CC", desc: "HIRE exempt wages and tips" },
  { code: "DD", desc: "Cost of employer-sponsored health coverage" },
  { code: "EE", desc: "Designated Roth contributions under governmental section 457(b)" },
  { code: "FF", desc: "Permitted benefits under a qualified small employer HRA" },
  { code: "GG", desc: "Income from qualified equity grants under section 83(i)" },
  { code: "HH", desc: "Aggregate deferrals under section 83(i) elections" },
];
